import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import React from "react";
import {
  Button,
  CreateButton,
  Datagrid,
  DateField,
  EditButton,
  List,
  NumberInput,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  ShowButton,
  SimpleList,
  TextField,
  TextInput,
  TopToolbar,
} from "react-admin";
import SecuredComponent from "server/security/SecuredComponent";
import { checkPermission } from "server/security/utils";
import { useNavigate } from "react-router";
import PaymentsIcon from "@mui/icons-material/Payments";
import { useMediaQuery } from "@mui/material";
import {
  HEALTHCARE_COURSE_DAILY_PRICES,
  HEALTHCARE_COURSE_FEE_DISTRIBUTION,
  MOBILE_BREAKPOINT,
  SpecialistServicePath,
} from "utils/constants";
import { specialistRequests } from "api/specialistApi";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";

const ListHealthcareCourses = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        <SecuredComponent permission={permissions.canPreviewHealthcareCourseDailyPrices}>
          <Button
            label="Дневни такси"
            startIcon={<PaymentsIcon />}
            variant="outlined"
            onClick={() => navigate(`/${SpecialistServicePath}${HEALTHCARE_COURSE_DAILY_PRICES}`)}
          />
        </SecuredComponent>
        <SecuredComponent permission={permissions.canPreviewHealthcareCourseFeeDistributions}>
          <Button
            label="Разпределение на такси"
            startIcon={<PaymentsIcon />}
            variant="outlined"
            onClick={() => navigate(`/${SpecialistServicePath}${HEALTHCARE_COURSE_FEE_DISTRIBUTION}`)}
          />
        </SecuredComponent>
        {hasCreate && <CreateButton />}
      </TopToolbar>
    );
  };

  const filters = [
    <TextInput
      source="name"
      label="Име"
      alwaysOn
    />,
    <NumberInput
      source="year"
      label="Година"
      alwaysOn
    />,
    <ReferenceInput
      reference={specialistRequests.getHealthcareSpecialitySelect()}
      source="speciality"
      alwaysOn
    >
      <SelectInput
        label="Специалност здравни грижи"
        optionText="nameBg"
        style={{ width: "400px" }}
        emptyText={"Всички"}
      />
    </ReferenceInput>,
  ];
  return (
    <List
      filters={filters}
      exporter={false}
      actions={<ListActions hasCreate={checkPermission(getPermissions(), permissions.canPreviewHealthcareCourses)} />}
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Име на български език", value: record?.nameBg }]} />
              <MobileListRow fields={[{ label: "Име на английски език", value: record?.nameEn }]} />
            </div>
          )}
          secondaryText={record => (
            <div>
              <MobileListRow
                fields={[
                  {
                    label: "Специалност здравни грижи",
                    value: (
                      <ReferenceField
                        reference={specialistRequests.getHealthcareSpecialitySelect()}
                        source="speciality"
                        sortable={false}
                      >
                        <TextField source="nameBg" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow fields={[{ label: "Година", value: record?.year }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Начало",
                    value: (
                      <DateField
                        source="fromDate"
                        locales="bg-BG"
                      />
                    ),
                  },
                  {
                    label: "Край",
                    value: (
                      <DateField
                        source="toDate"
                        locales="bg-BG"
                      />
                    ),
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={() => (
            <>
              <SecuredComponent permission={permissions.canManageHealthcareCourses}>
                <EditButton label="" />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canPreviewHealthcareCourses}>
                <ShowButton label="" />
              </SecuredComponent>
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="nameBg"
            label="Име на български език"
          />
          <TextField
            source="nameEn"
            label="Име на английски език"
          />
          <ReferenceField
            reference={specialistRequests.getHealthcareSpecialitySelect()}
            source="speciality"
            label="Специалност здравни грижи"
          >
            <TextField source="nameBg" />
          </ReferenceField>
          <TextField
            source="year"
            label="Година"
          />
          <DateField
            source="fromDate"
            label="Начало"
            locales="bg-BG"
          />
          <DateField
            source="toDate"
            label="Край"
            locales="bg-BG"
          />
          <SecuredComponent permission={permissions.canManageHealthcareCourses}>
            <EditButton />
          </SecuredComponent>
          <SecuredComponent permission={permissions.canPreviewHealthcareCourses}>
            <ShowButton />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};

export default ListHealthcareCourses;
